
class InvoiceCalculationEntity {

  constructor (
    allowance,
    amount,
    expense,
    fee,
    gross,
    invoiceValue,
    itp,
    itpTax,
    net,
    payrollTax,
    salaryTotal,
    tax,
    toPay,
    totalPayrollTax,
    travel,
    vacationGross,
    vacationNet,
    vacationPayrollTax,
    vat,
    userId
  ) {
    this.allowance = (allowance) ? +(allowance) : allowance;
    this.amount = (amount) ? +(amount) : amount;
    this.expense = (expense) ? +(expense) : expense;
    this.fee = (fee) ? +(fee) : fee;
    this.gross = (gross) ? +(gross) : gross;
    this.invoiceValue = invoiceValue;
    this.itp = itp;
    this.itpTax = itpTax;
    this.net = (net) ? +(net) : net;
    this.payrollTax = (payrollTax) ? +(payrollTax) : payrollTax;
    this.salaryTotal = (salaryTotal) ? +(salaryTotal) : salaryTotal;
    this.tax = (tax) ? +(tax) : tax;
    this.toPay = toPay;
    this.totalPayrollTax = totalPayrollTax;
    this.travel = travel;
    this.vacationGross = vacationGross;
    this.vacationNet = vacationNet;
    this.vacationPayrollTax = vacationPayrollTax;
    this.vat = (vat) ? +(vat) : vat;
    this.userId = parseInt(userId);
  }

}

export default InvoiceCalculationEntity;



/** WEBPACK FOOTER **
 ** ./src/frilans-finans/invoices/invoice-calculation-entity.js
 **/